import React from 'react';

interface DecimalNumberProps {
  num: number | null | undefined;
}

/**
 * Component to format decimal numbers with superscript decimal part
 * Handles negative numbers with parentheses and null/undefined values
 */
export const DecimalNumber: React.FC<DecimalNumberProps> = ({ num }) => {
  if (num === null || num === undefined || isNaN(num)) return <span>0</span>;
  if (num === 0) return <span>0</span>;

  // Handle negative numbers with parentheses
  if (num < 0) {
    const absoluteValue = Math.abs(num);
    const formatted = absoluteValue.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const [integerPart, decimalPart] = formatted.split('.');

    return (
      <span className="text-sm">
        ({integerPart}
        <sup className="text-[10px] top-[-3px] font-normal">.{decimalPart}</sup>)
      </span>
    );
  }

  const formatted = num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const [integerPart, decimalPart] = formatted.split('.');

  return (
    <span className="text-sm">
      {integerPart}
      <sup className="text-[10px] top-[-3px] font-normal">.{decimalPart}</sup>
    </span>
  );
};
